// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","687":"complete-application","718":"enter-bvn","936":"device-details"}[chunkId] + "." + {"594":"9eebd164","687":"cd2dd3f3","718":"10ffda7c","936":"6fceaa85"}[chunkId] + ".css";
};